import { Link, useLocation } from 'react-router-dom';
import React, { useEffect, useRef } from 'react';

interface NavAreaProps {
    className: string;
}

const interests = [
    "Front-End Web Developer",
    "Volleyball Player",
    "Golfer",
    "Crab Eater"
];

const navLinks = [
    { path: "/welcome", label: "Welcome" },
    { path: "/resume", label: "Résumé" },
    { path: "/portfolio", label: "Portfolio" }
];

const NavArea: React.FC<NavAreaProps> = ({ className }) => {
    const location = useLocation();
    const sectionRef = useRef<HTMLElement>(null);
    const sectionElement = sectionRef.current;

    let animationTimeout: NodeJS.Timeout;

    useEffect(() => {
        if (location.pathname !== "/") {
            document.body.classList.add("content-open");
        } else {
            document.body.classList.remove("content-open");
        }
    }, [location.pathname]);

    const isNotHomePage = () => {
        return location.pathname !== "/";
    };

    useEffect(() => {
        if (isNotHomePage()) {
            if (!document.body.classList.contains('not-homepage')) {
                document.body.classList.add('not-homepage');
            }
        }
    }, []);


    const getClassNames = () => {
        let classes = `navarea ${className}`;
        if (isNotHomePage()) {
            if (!classes.includes('active')) {
                classes += ' active';
            }
        } 
        if (document.body.classList.contains('not-homepage') && (sectionElement && sectionElement.classList.contains('active'))) {
            classes = `navarea active`;
        }
        return classes;
    };

    
    useEffect(() => {

        const handleAnimationStart = () => {
            if (sectionElement) {
                sectionElement.classList.add('animation-running');
            }
        };

        const handleAnimationEnd = () => {
            if (sectionElement) {
                animationTimeout = setTimeout(() => {
                    sectionElement.classList.remove('animation-running');
                }, 750); // 0.5 second buffer time
            }
        };

        const interestItems = sectionElement?.querySelectorAll('.interests li');
        const navItems = sectionElement?.querySelectorAll('.main-nav li');

        interestItems?.forEach(item => {
            item.addEventListener('animationstart', handleAnimationStart);
            item.addEventListener('animationend', handleAnimationEnd);
        });

        navItems?.forEach(item => {
            item.addEventListener('animationstart', handleAnimationStart);
            item.addEventListener('animationend', handleAnimationEnd);
        });
    }, []);

    return (
        <section ref={sectionRef} className={getClassNames()}>
            <ul className="interests">
                {interests.map((interest, index) => (
                    <li key={index} style={{ '--i': index } as React.CSSProperties}>{interest}</li>
                ))}
            </ul>
            <nav className="main-nav">
                <ul>
                    {navLinks.map((link, index) => (
                        <li key={index} style={{ '--i': index } as React.CSSProperties}>
                            <Link to={link.path} className={location.pathname === link.path ? 'active' : ''}>
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </section>
    );
}

export default NavArea;
